import { storableError } from '../util/errors';
import { createImageVariantConfig } from '../util/sdkLoader';
import { addMarketplaceEntities } from '../ducks/marketplaceData.duck';

// ================ Action types ================ //

export const FETCH_LISTINGS_REQUEST = 'app/listings/FETCH_LISTINGS_REQUEST';
export const FETCH_LISTINGS_SUCCESS = 'app/listings/FETCH_LISTINGS_SUCCESS';
export const FETCH_LISTINGS_ERROR = 'app/listings/FETCH_LISTINGS_ERROR';

// ================ Reducer ================ //

const fetchListingsInitialState = {
  inProgress: true,
  error: null,
};

const initialState = {};

const resultIds = data => {
  const listings = data.data;
  return listings
    .filter(l => !l.attributes.deleted && l.attributes.state === 'published')
    .map(l => l.id);
};

const listingsReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {

    case FETCH_LISTINGS_REQUEST:
      return {
        ...state,
        [payload]: fetchListingsInitialState,
      };

    case FETCH_LISTINGS_SUCCESS:
      return {
        ...state,
        [payload.type]: {
          ...state[payload],
          inProgress: false,
          resultIds: resultIds(payload.data)
        },
      };

    case FETCH_LISTINGS_ERROR:
      return {
        ...state,
        [payload.type]: {
          inProgress: false,
          error: payload.error,
        }
      };

    default:
      return state;
  }
}

export default listingsReducer;

// ================ Action creators ================ //

export const fetchListingsRequest = type => ({
  type: FETCH_LISTINGS_REQUEST,
  payload: type,
});

export const fetchListingsSuccess = (type, response) => ({
  type: FETCH_LISTINGS_SUCCESS,
  payload: { type, data: response.data },
});

export const fetchListingsError = (type, error) => ({
  type: FETCH_LISTINGS_ERROR,
  payload: { type, error },
});

// ================ Thunks ================ //

export const fetchListings = (type, queryParams, config) => (dispatch, getState, sdk) => {

  if (!type) return null;

  dispatch(fetchListingsRequest(type));

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const params = {
    ...queryParams,
    include: ['images'],
    'fields.listing': [
      'title',
      'price',
      'deleted',
      'state',
      'publicData',
    ],
    'fields.image': [
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-xlarge',
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    'limit.images': 1,
  }


  return sdk.listings
    .query(params)
    .then(response => {

      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };

      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(fetchListingsSuccess(type, response));
      return response;
    })
    .catch(e => {
      dispatch(fetchListingsError(type, storableError(e)));
      throw e;
    });
}
